var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('orderDetail',{attrs:{"data":_vm.orderDetail,"id":_vm.$route.query.id,"type":_vm.type}})}
var staticRenderFns = []

export { render, staticRenderFns }